import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { useSuspenseQuery } from '@tanstack/react-query';

import { useProductCenterApi } from 'api';
import { drivelineStructureQuery } from 'api/queries';
import { SectionTitleButtons } from 'library/components/controls/layout/SectionTitleButtons';
import { ServiceAreaTabs } from 'library/components/controls/layout/tabs/ServiceAreaTabs';
import { PageContentTab } from 'library/components/controls/pageTemplates/PageContent';
import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import { reactPlugin } from 'main/azureInsights/config';
import { ErrorComponentFallback } from 'main/errors/ErrorComponentFallback';
import { Drivelineview_Services_ServiceProtocols } from 'main/routes/urls/RouteUrls';
import { drivelineServicesAreaTabsConfiguration } from 'modules/Drivelineview/servicesAreaTabsConfiguration';
import { MaintenancePlannerButton } from 'modules/Shared/Components/Buttons/MaintenancePlannerButton';
import { useNumberParam } from 'modules/Shared/Components/Hooks/useNumberParam';

const ServiceAreaPage = (): React.JSX.Element => {
	const id = useNumberParam('id');
	const { api } = useProductCenterApi();
	const { trackApplicationInteraction } = useAdobeTracking();
	const { data: driveline } = useSuspenseQuery(
		drivelineStructureQuery(api, id)
	);

	const visibleTabs = driveline.isServiceProtocolAvailable
		? drivelineServicesAreaTabsConfiguration
		: drivelineServicesAreaTabsConfiguration.filter(
				(tab) => tab.path !== Drivelineview_Services_ServiceProtocols
			);

	return (
		<>
			<SectionTitleButtons>
				<MaintenancePlannerButton source="DrivelineView" />
			</SectionTitleButtons>
			<ServiceAreaTabs
				tabs={visibleTabs}
				onTabClick={(tabPath) =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'DRIVELINEVIEW Service Area Tab Navigation',
						selectedOptions: [{ attribute: 'tab', value: tabPath }],
					})
				}
			/>
			<PageContentTab ErrorFallbackComponent={ErrorComponentFallback} />
		</>
	);
};

export default withAITracking(
	reactPlugin,
	ServiceAreaPage,
	'DrivelineViewServiceAreaPage',
	'application-insight-container'
);
